import cn from "classnames"
import React from "react"

import styles from "./index.module.css"

type QuoteProps = {
  view: "small" | "big"
  className?: string
}

export const Quote: React.FC<QuoteProps> = ({ view, children, className }) => {
  const clsName = cn(className, {
    [styles.Small]: view === "small",
    [styles.Big]: view === "big",
  })

  return <div className={clsName}>{children}</div>
}
